import React, { useState } from 'react'
import DatePicker from '../../components/FormFields/DatePicker';
import CustomButton from '../../components/CustomButton';
import ToolbarHeader from '../../components/ToolbarHeader';
import moment from 'moment';
import { useAuth } from '../../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { apiUrls } from '../../utils/api/apiUrls';
import { downloadReportsFun } from '../../utils/helpers';
import { toast } from 'react-toastify';
import useApi from '../../hooks/useApi';

const VoucherReportDownload = () => {
    const [searchParams] = useSearchParams();
    const {
      user: { userLabel = "Store" },
      selectedStores,
    } = useAuth();
  
    const [startDate, setStartDate] = useState(
      moment(
        searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
      ).toDate()
    );
  
    const [endDate, setEndDate] = useState(
      moment(searchParams.get("endDate") || new Date()).toDate()
    );
    const {apiCall: fileDownload} = useApi();
  
    const downloadFileFun = () => {
        const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
        const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
        fileDownload({
          url: `${apiUrls.dmsService.downloadConsolidatedVoucherReport}?endDate=${et}&startDate=${st}`,
          method: "post",
          responseType: "blob",
          responseData: (res) => {
            const { data = "", status = null } = res || {};
            // debugger
            const contentType = res?.headers?.["content-type"];
            const contentDisposition = res?.headers["content-disposition"];
            const fileNameMatch =
              contentDisposition && contentDisposition.match(/filename="(.+)"/);
            const fileName = fileNameMatch
              ? fileNameMatch[1]
              : "VoucherJourneyReport.xlsx";
            if(status === 200) {
              toast.success("Download File Successfully");
              downloadReportsFun(data, fileName, contentType);
            } else {
              toast.success("Something Went Wrong");
            }
          },
        });
    }
    const voucherApiCall = (start, end) => {
      // navigate(
      //   {
      //     pathname: window.location.pathname,
      //     search: createSearchParams({
      //       startDate: start,
      //       endDate: end,
      //     }).toString(),
      //   },
      //   { replace: true }
      // );
        // apiCall({
        //   url: apiUrls.dmsService.getRecords,
        //   dataToSend: {
        //     startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        //     metadataSchemaId: 4,
        //     endDate: moment(end || start)
        //       .endOf("d")
        //       .format("YYYY-MM-DD HH:mm:ss"),
        //     searchText: "",
        //     status: null,
        //     storeCodes: selectedStores?.storeDetails?.storeCode
        //       ? [selectedStores?.storeDetails?.storeCode]
        //       : undefined,
        //   },
        //   method: "post",
        //   processData: userLabel === "Store",
        //   accessor: "storeGetResponse",
        //   itemAccessor: "dataModalRecordsResponse",
        // });
    };
  
    const onChangeDate = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      if (end) voucherApiCall(start, end);
    };

    return (
      <div className="dashboard-container">
        <ToolbarHeader
          title="Voucher Report"
          showBack={false}
          containerClassName="mt-14"
          // renderRight={() => {
          //   if (userLabel !== "Store") {
          //     return null;
          //   }
          //   return (
          //     <CustomButton
          //       title="Submit Cash Deposit"
          //       icon={icons.plusIcon}
          //       onClick={onClickSubmitCashDeposit}
          //     />
          //   );
          // }}
        />
        <div className="flex justify-start items-center bg-[var(--whiteColor)] rounded-[1rem] mt-8 px-4 py-7">
          <div className="flex items-center gap-x-3 self-end">
            <div className="font-size-medium">Date Range</div>
            <DatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={onChangeDate}
              maxDate={new Date()}
              dateRange
            />
          </div>
          <CustomButton
            title="Download"
            wrapperClassName={`self-end !px-10 ml-6`}
            onClick={downloadFileFun}
          />
        </div>
      </div>
    )
  }

export default VoucherReportDownload